import { MouseEventHandler, useCallback, useEffect, useRef, useState } from 'react'
import styles from './VideoPlayer.module.less'
import Player from 'xgplayer'
import 'xgplayer/dist/index.min.css'
import AIcon from '@/components/A/AIcon/AIcon'
import cls from 'classnames'

interface Props {
  id?: string
  className?: string
  currentTime?: number
  url: string
  onVideoReady?: (instance: Player) => void
  noPlayButton?: boolean
  controls?: boolean
  onError?: () => void
  fitMode?: 'cover' | 'contain'
}

function VideoPlayer(props: Props) {
  const id = props.id || 'video-player'
  const controls = props.controls === undefined ? true : props.controls
  const [playerInstance, setPlayerInstance] = useState<Player | undefined>(undefined)
  const [playerIsReady, setPlayerIsReady] = useState<boolean>(false)
  const [playStatus, setPlayStatus] = useState<'pause' | 'play'>('pause')
  const root = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const instance = new Player({
      url: props.url,
      el: root.current!,
      fluid: true,
      autoplay: false,
      videoFillMode: props.fitMode === 'contain' ? 'contain' : 'cover',
      /** 视频封面图 */
      poster: '',
      /** 如果没有设置 poster, 这个设置初始化显示视频首帧 */
      videoInit: true,
      /** 默认音量 */
      volume: 0,
      playbackRate: [1],
      pip: false,
      controls,
      keyboard: {
        keyCodeMap: {
          'space': {
            disable: true
          }
        }
      },
      closeDelayBlur: true,
      /** 禁用右键菜单 */
      enableContextMenu: false,
      /** 禁用双击全屏/退出全屏 */
      closeVideoDblclick: true,
      /** 禁用移动端双击 */
      enableVideoDbltouch: false,
      /** 禁用右键菜单 */
      enableContextmenu: false,
      /** 禁用内置控件 ['time', 'definition', 'error', 'fullscreen', 'i18n', 'loading', 'mobile', 'pc', 'play', 'poster', 'progress', 'replay', 'volume'] */
      ignores: ['fullscreen', 'definition', 'cssfullscreen', 'playbackRate',],
      lang: 'en',
      commonStyle: {
        // playedColor: '#6d54fa',
        // cachedColor: '#858585',
      },
    })
    instance.once('ready', () => {
      setPlayerIsReady(true)
    })
    instance.on('pause', () => {
      setPlayStatus('pause')
    })
    instance.on('play', () => {
      setPlayStatus('play')
    })
    instance.on('loadedmetadata', () => {
      props.onVideoReady?.(instance)
    })
    instance.on('error', (e) => {
      console.log('error', e)
      props.onError?.()
    })
    setPlayerInstance(instance)
    return () => {
      instance.destroy()
    }
  }, [])

  useEffect(() => {
    if (playerInstance) {
      playerInstance.src = props.url
    }
  }, [props.url, playerInstance])

  // useEffect(() => {
  //   if (props.currentTime !== undefined && playerInstance) {
  //     playerInstance.currentTime = props.currentTime

  //     if (playStatus === 'play') {
  //       playerInstance.play()
  //     }
  //   }
  // }, [props.currentTime, playerInstance, playStatus])

  const handlePlayVideo: MouseEventHandler<HTMLSpanElement> = useCallback(
    (event) => {
      event.stopPropagation()
      if (playerInstance) {
        playerInstance.play()
      }
    },
    [playerInstance]
  )

  useEffect(() => {
    if (playerIsReady && playerInstance && props.currentTime !== undefined) {
      playerInstance.currentTime = props.currentTime
    }
  }, [playerInstance, playerIsReady, props.currentTime])


  return (
    <div className={cls(styles.videoPlayerBox, props.fitMode === 'contain' && styles.contain, props.className)}>
      {playStatus === 'pause' && !props.noPlayButton && (
        <span className={styles.playerIcon} onClick={handlePlayVideo}>
          <AIcon type='icon-fill-global_play2' width={18} height={18}></AIcon>
        </span>
      )}
      <div id={id} ref={root} className={styles.videoPlayer}></div>
    </div>
  )
}

export default VideoPlayer
